import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify);

export default new Vuetify({
    options: {
        customProperties: true
    },
    theme: {
        themes: {
            light: {
                background: '#FFFFFF',
                primary: '#85C1E9',
                primaryDark: '#FFFFFF',
                rowAlternate: '#000000',
                secondary: '#3498DB',
                accent: '#F5B041',
                error: '#FF5252',
                info: '#2196F3',
                success: '#4CAF50',
                warning: '#FFC107',
                text: '#000000',
            },
            dark: {
                background: '#121212',
                primary: '#686767',
                primaryDark: '#686767',
                rowAlternate: '#222222',
                secondary: '#FFFFFF' ,
                accent: '#BB86FC',
                error: '#FF5252',
                info: '#2196F3',
                success: '#4CAF50',
                warning: '#FFC107',
                text: '#ffffff'
            },
        },
    }
});

